import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './redux/store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { MuiThemeProvider, createMuiTheme, makeStyles } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 14,
    htmlFontSize: 17,
    fontFamily: ['DINNextLTPro-Regular', 'sans-serif']

  },
  palette: {
    primary: {
      light: '#4b5e6b',
      main: '#223440',
      dark: '#000d1a',
      contrastText: '#fff',
    },
    secondary: {
      light: '#66f5ed',
      main: '#19c2bb',
      dark: '#00918b',
      contrastText: '#000',
    },
    blanco: {
      light: '#fff',
      main: '#fff',
      dark: '#fff',
      contrastText: '#fff',
    }
  },
})

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </BrowserRouter>
    </Provider>
  </MuiThemeProvider>
  , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();